import { useEffect, useState } from "react";
import "./../layout.css";
import { Breadcrumb, Layout, Menu, Modal, Typography } from 'antd';
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { DownloadOutlined, HomeFilled, SwitcherFilled,  } from "@ant-design/icons";
import { BsFileTextFill, BsPeopleFill } from "react-icons/bs";
import { FiLogOut } from "react-icons/fi";
import { useDispatch } from "react-redux";
import { logoutUser } from "../../../redux/actions/LoginActions";

const { Sider, Content } = Layout;

const SideBar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedKey, setSelectedKey] = useState();
  const dispatch = useDispatch();
  const [openModalConfirmation, setOpenModalConfirmation] = useState();

  const handleOpenModalConfirmation = () => {
        setOpenModalConfirmation(true);
  };

  const handleCancelConfirmation = () => {
        setOpenModalConfirmation(false);
  };


  const items = [
    { key: "1", icon: <HomeFilled />, label: "Tableau de bord", path: "/dashboard" },
    { key: "2", icon: <SwitcherFilled />, label: "Formulaires", path: "/dashboard/formulaires" },
    { key: "5", icon: <BsPeopleFill />, label: "Utilisateurs", path: "/dashboard/utilisateurs", },
    { key: "8", icon: <BsFileTextFill />, label: "Journal d'audit", path: "/dashboard/journal" },
  ];

 

  useEffect(() => {
  const findKey = (itemsList, path) => {
    for (const item of itemsList) {
      if (item.path === path) return item.key;
      if (item.children) {
        const child = item.children.find(sub => sub.path === path);
        if (child) return child.key;
      }
    }
    return null;
  };

  const key = findKey(items, location.pathname);
  setSelectedKey(key || ""); 
}, [location.pathname]);

  
  const handleMenuClick = (e) => {
    const findPath = (itemsList, key) => {
      for (const item of itemsList) {
        if (item.key === key && item.path) return item.path;
        if (item.children) {
          const child = item.children.find(sub => sub.key === key);
          if (child && child.path) return child.path;
        }
      }
      return null;
    };

    const path = findPath(items, e.key);
    if (path) {
      navigate(path);
      setSelectedKey(e.key);
    }
  };

   const handleLogout = () => {
    dispatch(logoutUser()); 
    navigate("/");
  }
  return (
    <div className="divGlobal">
      <Layout>
        <Sider className="siderSexion">
          <Menu
            className="menuSexion"
            selectedKeys={[selectedKey]}
            theme="light"
            defaultOpenKeys={["5"]}
            mode="inline"
            onClick={handleMenuClick}
            items={items.map(item => {
              if (item.children) {
                return {
                  ...item,
                  children: item.children.map(sub => ({
                    key: sub.key,
                    label: <span>{sub.label}</span>,
                    path: sub.path
                  }))
                };
              }
              return item;
            })}
          />
          <div onClick={handleOpenModalConfirmation} style={{ color: "#000", display: "flex", alignItems: "center", justifyContent: "center", marginLeft: "-20%" , cursor:"pointer", marginTop:"5%"}}>
            <FiLogOut style={{ marginRight: "7px" }} /> Déconnexion
          </div>
        </Sider>

        <Content className="contenuSexion">
          <Breadcrumb className="breadcrumbSexion">
            <Breadcrumb.Item>
              <Typography.Title level={3} className="" >
                {items.find(item => item.key === selectedKey)?.label ||
                  items.flatMap(i => i.children || []).find(sub => sub.key === selectedKey)?.label}
              </Typography.Title>
            </Breadcrumb.Item>
          </Breadcrumb>

          <div style={{ marginTop: "2%", marginLeft:"2%" }}>
            <Outlet />
          </div>
        </Content>
      </Layout>

            {/* LES MODALS */}
          <Modal
              maskClosable={false}
              closable={false}
              title="Déconnexion" 
              open={openModalConfirmation} 
              onOk={handleLogout}       
              onCancel={handleCancelConfirmation}
              okText="Oui" 
              cancelText="Non" okButtonProps={{ style: { backgroundColor: '#42C90E', borderColor: '#42C90E', color: 'white' } }} >
              <p>Voulez-vous vous déconnecter?</p>
           </Modal>            

    </div>
  );
};

export default SideBar;
